module.exports = __webpack_public_path__ + "img/isbar1.7ef7467f.png";